import { ActionTypes } from './actionTypes';
import catalogServices from '../../services/catalogServices';
import nProgress from 'nprogress';
import { notification } from 'antd';
import miscServices from '../../services/miscServices';
import { toast } from 'react-hot-toast';

export const resetCatalog = () => (dispatch) => {
  dispatch({
    type: ActionTypes.RESET_CATALOG,
  });
};

export const setCatalog = (payload) => ({
  type: ActionTypes.SET_CATALOG,
  payload,
});

export const updateCatalogCount = (count) => {
  return {
    type: ActionTypes.SET_CATALOG_COUNT,
    payload: count,
  };
};

export const updateCatelog = (payload, catelogSection) => async (dispatch) => {
  let sendPayload = {
    data: payload,
    catelogSection: catelogSection,
  };
  dispatch({
    type: ActionTypes.UPDATE_CATELOG,
    payload: sendPayload,
  });
};

export const setCatalogFormEditable = () => {
  return {
    type: ActionTypes.SET_CATALOG_FORM_EDITABLE,
  };
};

export const sendCatalogueFormError = (error, dispatch) => {
  notification.error({
    message: error?.data?.error?.err_message,
    //description: error?.data?.error,
    duration: '20',
  });
  nProgress.done();
  dispatch(updateCatalogFormFailure(error));
};

export const updateCatalogFormFailure = (error) => {
  // const message =
  //   (error.response && error.response.data && error.response.data.message) ||
  //   error.message ||
  //   error.toString();
  const message =
    error?.data?.error?.additional_data?.message?.toString() ||
    error?.data?.error?.err_message?.toString() ||
    'Failed!';
  return {
    type: ActionTypes.MANAGE_CATALOG_FORM_FAILURE,
    payload: message,
  };
};

export const postCatalogueBrandDetailsAction =
  (payload) => async (dispatch) => {
    dispatch({
      type: ActionTypes.MANAGE_CATALOG_FORM_LOADING,
    });
    nProgress.start();
    try {
      const response = await catalogServices.postCatalogueBrandDetails(payload);
      nProgress.done();
      if (response.status == 'Success') {
        dispatch({
          type: ActionTypes.MANAGE_CATALOG_BRAND_FORM_SUCCESS,
          payload: response.data,
        });
        dispatch(updateCatalogCount(1));
      }
    } catch (error) {
      sendCatalogueFormError(error, dispatch);
    }
  };

export const postCatalogueFranchiseDetailsAction =
  (payload) => async (dispatch) => {
    dispatch({
      type: ActionTypes.MANAGE_CATALOG_FORM_LOADING,
    });
    nProgress.start();
    try {
      const response = await catalogServices.postCatalogueFranchiseDetails(
        payload
      );
      nProgress.done();
      if (response.status == 'Success') {
        dispatch({
          type: ActionTypes.MANAGE_CATALOG_FORM_SUCCESS,
          payload: response.data,
        });
        dispatch(updateCatalogCount(2));
      }
    } catch (error) {
      sendCatalogueFormError(error, dispatch);
    }
  };

export const postCataloguePagesDetailsAction =
  (payload) => async (dispatch) => {
    dispatch({
      type: ActionTypes.MANAGE_CATALOG_FORM_LOADING,
    });
    nProgress.start();
    try {
      const response = await catalogServices.postCataloguePagesDetails(payload);
      nProgress.done();
      if (response.status == 'Success') {
        dispatch({
          type: ActionTypes.MANAGE_CATALOG_FORM_SUCCESS,
          payload: response.data,
        });
        dispatch(updateCatalogCount(3));
      }
    } catch (error) {
      sendCatalogueFormError(error, dispatch);
    }
  };

export const postCatalogueAdditionalDetailsAction =
  (payload) => async (dispatch) => {
    dispatch({
      type: ActionTypes.MANAGE_CATALOG_FORM_LOADING,
    });
    nProgress.start();
    try {
      const response = await catalogServices.postCatalogueAdditionalDetails(
        payload
      );
      nProgress.done();
      if (response.status == 'Success') {
        dispatch({
          type: ActionTypes.MANAGE_CATALOG_FORM_SUCCESS,
          payload: response.data,
        });
        dispatch(updateCatalogCount(4));
      }
    } catch (error) {
      nProgress.done();
      dispatch(updateCatalogFormFailure(error));
    }
  };

export const postCataloguePhotosDocsDetailsAction =
  (payload) => async (dispatch) => {
    dispatch({
      type: ActionTypes.MANAGE_CATALOG_FORM_LOADING,
    });
    nProgress.start();
    try {
      const response = await catalogServices.postCataloguePhotosDocslDetails(
        payload
      );
      nProgress.done();
      if (response.status == 'Success') {
        dispatch({
          type: ActionTypes.MANAGE_CATALOG_FORM_SUCCESS,
          payload: response.data,
        });
        dispatch(updateCatalogCount(5));
      }
    } catch (error) {
      sendCatalogueFormError(error, dispatch);
    }
  };

export const postCatalogueAlternativeContactDetailsAction =
  (payload) => async (dispatch) => {
    dispatch({
      type: ActionTypes.MANAGE_CATALOG_FORM_LOADING,
    });
    nProgress.start();
    try {
      const response =
        await catalogServices.postCatalogueAlternativeContactDetails(payload);
      nProgress.done();

      if (response.status === 'Success') {
        toast.success('Brand Catalogue submitted successfully!');
        dispatch({
          type: ActionTypes.MANAGE_CATALOG_FORM_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error) {
      sendCatalogueFormError(error, dispatch);
    }
  };

export const getCatalogDetailsAction = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.FETCH_CATALOG_DETAILS_LOADING,
  });
  nProgress.start();
  try {
    const response = await catalogServices.getCatalogDetails();
    nProgress.done();
    if (response.status == 'Success') {
      dispatch({
        type: ActionTypes.FETCH_CATALOG_DETAILS_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    nProgress.done();
    dispatch(updateCatalogFormFailure(error));
    dispatch({
      type: ActionTypes.FETCH_CATALOG_DETAILS_FAILURE,
      payload: 'Failed!',
    });
  }
};

export const getDropdownData = () => async (dispatch) => {
  nProgress.start();
  try {
    const response = await catalogServices.getDropdownData();
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_DROPDOWN_DATA,
        payload: response,
      });
    }
  } catch (error) {
  } finally {
    nProgress.done();
  }
};
export const getIndustryData = () => async (dispatch) => {
  nProgress.start();
  try {
    const response = await catalogServices.getIndustryData();
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_INDUSTRY,
        payload: response,
      });
    }
  } catch (error) {
  } finally {
    nProgress.done();
  }
};

export const getBussinessCategoryData = (params) => async (dispatch) => {
  nProgress.start();
  try {
    const response = await catalogServices.getBussinessCategoryData(params);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_BUSSINESS_CATEGORY_DATA,
        payload: response,
      });
    }
  } catch (error) {
  } finally {
    nProgress.done();
  }
};

export const getBussinessTypeData = (sup_cat_id) => async (dispatch) => {
  try {
    const response = await catalogServices.getBussinessTypeData(sup_cat_id);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_BUSSINESS_TYPE_DATA,
        payload: response,
      });
    }
  } catch (error) {
  } finally {
  }
};

export const getCostBifurcationsData = (sup_cat_id) => async (dispatch) => {
  try {
    const response = await catalogServices.getCostBifurcationsData(sup_cat_id);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_COST_BIFURCATION_DATA,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};
export const getEmployeeDetailsData = (sup_cat_id) => async (dispatch) => {
  try {
    const response = await catalogServices.getEmployeeDetailsData(sup_cat_id);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_EMPLOYEE_DETAILS_DATA,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};
export const getLicenseTypeData = (sup_cat_id) => async (dispatch) => {
  try {
    const response = await catalogServices.getLicenseTypeData(sup_cat_id);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.GET_LICENSE_TYPE_DATA,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};

export const setBrandUser = (user) => (dispatch) => {
  dispatch({
    type: ActionTypes.SET_BRAND_USER,
    payload: user,
  });
};

export const fetchCountryData = () => async (dispatch) => {
  try {
    const response = await miscServices.getCountriesData();
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.FETCH_COUNTRIES,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};

export const fetchStatesData = (params) => async (dispatch) => {
  try {
    const response = await miscServices.getStatesData(params);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.FETCH_STATES,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};
export const fetchCitiesData = (params) => async (dispatch) => {
  try {
    const response = await miscServices.getCitiesData(params);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.FETCH_CITIES,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};

export const publishCatalogAction = (cat_id) => async (dispatch) => {
  dispatch({
    type: ActionTypes.PUBLISH_CATALOG_LOADING,
  });
  nProgress.start();
  try {
    const response = await catalogServices.publishCatalog(cat_id);
    nProgress.done();
    console.log('publish response', response);
    if (response.status == 'Success') {
      toast.success('Catalogue published successfully!');
      dispatch({
        type: ActionTypes.PUBLISH_CATALOG_SUCCESS,
        payload: {
          message: response?.message,
          catalog: response?.data,
        },
      });
    } else {
      notification.error({
        message: response?.data?.error?.err_message,
        //description: response?.error,
        duration: '20',
      });
      toast.error(response?.data?.error?.err_message);
      dispatch({
        type: ActionTypes.PUBLISH_CATALOG_FAILURE,
        payload: response?.data?.error,
      });
    }
  } catch (error) {
    toast.error(error?.data?.error?.err_message || 'Error!');
    notification.error({
      message: error?.data?.error?.err_message,
      //description: error?.data?.error,
      duration: '20',
    });
    nProgress.done();
    dispatch({
      type: ActionTypes.PUBLISH_CATALOG_FAILURE,
      payload: error,
    });
  }
};

export const fetchZones = (params) => async (dispatch) => {
  try {
    const response = await miscServices.getAllZones(params);
    if (response.status === 'Success') {
      dispatch({
        type: ActionTypes.FETCH_ZONES,
        payload: response?.data,
      });
    }
  } catch (error) {
  } finally {
  }
};
